<script lang="ts">
  import Search from "$lib/docs/Search.svelte";
  import {
    closeMobileMenu,
    themeStore,
  } from "$routes/(microsites)/gpu-glossary/_lib/gpu-glossary";
</script>

<div
  class="gpu-glossary"
  style:--primary-color={$themeStore.primary[100]}
  style:--background-color={$themeStore.secondary[100]}
  style:--primary-color-light={$themeStore.primary[60]}
>
  <Search
    indexName="gpu_glossary"
    placeholder="Search GPU Glossary"
    onClose={closeMobileMenu}
    trigger="docsearch"
  />
</div>

<style lang="postcss">
  @reference "$app.css";

  .gpu-glossary :global(.DocSearch-Button) {
    background-color: var(--background-color) !important;
    height: auto;
    @apply ml-0 h-[32px] w-full rounded-none border border-transparent px-3 py-1 font-normal text-(--primary-color) ring-1 ring-transparent transition-all sm:h-auto;
  }
  .gpu-glossary :global(.DocSearch-Button):hover {
    @apply text-(--primary-color) ring-(--primary-color-light);
  }
  .gpu-glossary :global(.DocSearch-Button .DocSearch-Search-Icon) {
    @apply h-4 w-4 stroke-2 text-(--primary-color-light) opacity-60;
  }
  .gpu-glossary :global(.DocSearch-Button .DocSearch-Button-Placeholder) {
    @apply hidden px-2 text-sm md:block xl:pr-24;
  }
  .gpu-glossary :global(.DocSearch-Button .DocSearch-Button-Keys) {
    @apply hidden min-w-0 lg:flex;
  }
  .gpu-glossary :global(.DocSearch-Button .DocSearch-Button-Key) {
    background: none;
    @apply mt-0.5 mr-0 ml-1 w-auto p-0 font-sans text-sm text-(--primary-color-light);
  }
</style>
